export const generateFormattedDate = (date = new Date()): string =>
  new Intl.DateTimeFormat("en", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })
    .format(date)
    .split(".")
    .join("/");
